<template>
    <div :class="serviceNameLowerCase + 'hp'">
        <sag-right-side-bar-base
            :name="name"
            :serviceName="serviceName"
            @submitEvent="submitEvent"
            @displayEvent="displayEvent"
            @btnClick="emitBtnClickInit"
        >

            <template>
                <b-row>
                    <sag-form-text-box
                        :sagValue="formData.CourseCode"
                        id="CourseCode"
                        label="課程代碼"
                        @sagChangeEvent="dataChange"
                        @sagRefreshData="receiver"
                        readonly
                    />
                    <sag-form-number
                        :sagValue="formData.CourseHours"
                        id="CourseHours"
                        label="訓練時數"
                        @sagChangeEvent="dataChange"
                        @sagRefreshData="receiver"
                        readonly
                    />
                </b-row>
                <b-row>
                    <sag-form-text-box 
                        :sagValue="formData.CoursePlace"
                        id="CoursePlace"
                        label="授課地點"
                        @sagChangeEvent="dataChange"
                        @sagRefreshData="receiver"
                        readonly
                    />
                    <sag-form-date-timepicker
                        :sagValue="formData.CourseDateTimeS"
                        id="CourseDateTimeS"
                        label="授課日期時間"
                        @sagChangeEvent="dataChange"
                        @sagRefreshData="receiver"
                        readonly
                    />
                </b-row>
                <b-row class="align-items-end">
                    <sag-form-text-box 
                        :sagValue="formData.CourseTeacher"
                        id="CourseTeacher"
                        label="授課講師"
                        @sagChangeEvent="dataChange"
                        @sagRefreshData="receiver"
                        readonly
                    />
                    <sag-button label="ICON"/>
                </b-row>
                <b-row>
                    <sag-form-textarea 
                        :sagValue="formData.Mark"
                        id="Mark"
                        label="備註"
                        @sagChangeEvent="dataChange"
                        @sagRefreshData="receiver"
                        readonly
                    />
                </b-row>
                <b-row>
                    <sag-form-checkbox 
                        :sagValue="formData.IsCancel"
                        id="IsCancel" 
                        label="是否取消"
                        @sagChangeEvent="dataChange"
                        @sagRefreshData="receiver"
                        disabled
                    />
                </b-row>
            </template>
            
        </sag-right-side-bar-base>
    </div>
</template>
<script>
import SagRightSideBarBase from '@/components/sag-right-side-bar/SagRightSideBarBase.vue'
import SagFormTextBox from '@/components/basic/SagFormTextBox.vue'
import SagFormDateTimepicker from '@/components/basic/SagFormDateTimepicker.vue'
import SagFormCheckbox from '@/components/basic/SagFormCheckbox.vue'
import SagFormTextarea from '@/components/basic/SagFormTextarea.vue'
import SagButton from '@/components/basic/SagButton.vue'
import SagFormNumber from '@/components/basic/SagFormNumber.vue'
import { computed, reactive, ref } from '@vue/composition-api'
import pageJs from './js'

import tools from '@/sag-core/tools'
import store from '@/store'
import {
    BIconPlusSquare,
    BRow, 
    BCol, 
} from 'bootstrap-vue'
export default {
    components: {
        SagFormTextBox,
        SagFormDateTimepicker,
        SagFormCheckbox,
        SagFormTextarea,
        SagButton,
        SagRightSideBarBase,
        BRow, 
        BCol,
        SagFormNumber,
        BIconPlusSquare
    },
    props: {
        GridData: {
            type: Object,
            required: true
        },
        name: {
            type: String,
            required: true
        }
    },
    setup(props, { emit }) {

        const serviceName = pageJs.page.pageInfo.serviceName

        let emitBtnClick = ()=>{}
        const emitBtnClickInit = (func)=>{
            emitBtnClick = func
        }

        const serviceNameLowerCase = computed(()=>{
            return serviceName.toLowerCase()
        })

        const formData = reactive({
            CourseCode: '',
            CourseDateTimeS: '',
            CourseDateTime: '',
            CourseHours: 0,
            CourseTeacher: '',
            CoursePlace: '',
            Mark: '',
            IsCancel: false,
            CreateDate: '',
            CreateUser: '',
            ModifyDate: '',
            ModifyUser: ''
        })

		// 確認送出事件
        const submitEvent = ()=>{

        }

        // 顯示狀態變更事件
        const displayEvent = (isDisplay)=>{

        }
    
        // 雙向綁定
        const dataChange = (data)=>{
            formData[data.name] = data.value
        }

        const formRefreshDataMethod = {}
        const previewData = ()=>{
            for(let key in formData){
                if(props.GridData.current.data && key in props.GridData.current.data){
                    if(key in formRefreshDataMethod){
                        if(typeof(formRefreshDataMethod[key]) === 'function'){
                            formRefreshDataMethod[key](props.GridData.current.data[key])
                        }
                        else{
                            // console.log(`${key} 的 refresh method不是function`, formRefreshDataMethod[key])
                        }
                    }
                    else{
                        // console.log(`${key} 沒有 refresh method`)
                    }
                }
            }
        }

        // 修改Modal事件拋出(初始化)
        props.GridData.currentDataChangeEvent[`${props.name}/previewData`] = previewData

        store.dispatch(`${serviceName}/eventAdd`, {
            name: `${props.GridData.name}/sagBasicTable/previewModalOpen`,
            event: ()=>{
                btnClick()
            }
        })

        // 按鈕觸發
        const btnClick = ()=>{
            emitBtnClick(true)
        }

        // 接收輸入控制項refresh method
        const receiver = (prop)=>{
            formRefreshDataMethod[prop.key] = prop.value
        }

        return {
            serviceNameLowerCase,
            serviceName,
            formData,
            dataChange,
            receiver,
            submitEvent,
            displayEvent,
            emitBtnClickInit,
            btnClick
        }
    },
}
</script>
